// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__2SoHm","icon":"style_icon__u8jB6","title":"style_title__3RYoc"};